import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { useTranslation } from 'react-i18next';
import langArrowIcon from '../assets/lang-arrow.svg';
import { trackLanguageChange, trackClick } from '../analytics';

const Header = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const modalLangRef = useRef(null);
  
  const { t, i18n } = useTranslation();
  // useTranslation hook automatically re-renders when language changes
  const currentLanguage = i18n.language;

  const openLanguageModal = () => {
    setModalOpen(true);
    document.body.classList.add('langs-expanded');
    if (modalLangRef.current) {
      modalLangRef.current.classList.add('is-open');
    }
    trackClick('language_modal', 'open_language_modal');
  };

  const closeLanguageModal = () => {
    setModalOpen(false);
    document.body.classList.remove('langs-expanded');
    if (modalLangRef.current) {
      modalLangRef.current.classList.remove('is-open');
    }
    trackClick('language_modal', 'close_language_modal');
  };

  const changeLanguage = async (language) => {
    try {
      await i18n.changeLanguage(language);
      localStorage.setItem('selectedLanguage', language);
      trackLanguageChange(language);
      closeLanguageModal();
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  useEffect(() => {
    const changeLangEvent = document.getElementById('langsSwitcher');
    if (changeLangEvent) {
      changeLangEvent.addEventListener('touchend', (event) => {
        event.preventDefault();
      });
    }
  }, []);

  return (
    <div>
      <header className="wrap-header">
        <div className="header">
          <div className="header__actions header-actions header-actions--left">
          </div>
          <a href="/" className="header__logo logo" onClick={() => trackClick('navigation', 'logo_click')}>
            <picture className="logo__img">
              <img src="/logo.png" width="46" height="25" alt="Valentino" />
            </picture>
          </a>
          <div className="header__actions header-actions header-actions--right">
            <div className="header-actions__item" id="language-btn">
              <a
                onClick={openLanguageModal}
                onTouchStart={openLanguageModal}
                href="#langs"
                className="header-actions__btn header-actions__btn--langs js-open-modal"
                data-modal="#langs"
                id="langsSwitcher"
              >
                <span>{currentLanguage.toUpperCase()}</span>
                <img src={langArrowIcon} alt="" className="lang-arrow-icon" />
              </a>
            </div>
          </div>
        </div>
      </header>
      <div className="modal modal--langs" id="langs" ref={modalLangRef} aria-hidden="true">
        <div className="modal-top-bar">
          <div className="modal-title">{t('SELECT_LANGUAGE_MODAL_TITLE')}</div>
          <button
            className="lang-close-model"
            type="button"
            aria-label="Close"
            onClick={closeLanguageModal}>
            ×
          </button>
        </div>
        <div className="lang-actions">
          <div className={`lang-actions__item ${currentLanguage === 'cht' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('cht')} className="lang-actions__btn btn">
              {currentLanguage === 'cht' ? 'CHT - 繁體中文' : 'CHT | 繁體中文'}
            </button>
          </div>

          <div className={`lang-actions__item ${currentLanguage === 'chs' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('chs')} className="lang-actions__btn btn">
              {currentLanguage === 'chs' ? 'CHS - 简体中文' : 'CHS | 简体中文'}
            </button>
          </div>

          <div className={`lang-actions__item ${currentLanguage === 'jp' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('jp')} className="lang-actions__btn btn">
              {currentLanguage === 'jp' ? 'JP - 日本語' : 'JP | 日本語'}
            </button>
          </div>

          <div className={`lang-actions__item ${currentLanguage === 'en' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('en')} className="lang-actions__btn btn">
              {currentLanguage === 'en' ? 'EN - English' : 'EN | English'}
            </button>
          </div>

          <div className={`lang-actions__item ${currentLanguage === 'it' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('it')} className="lang-actions__btn btn">
              {currentLanguage === 'it' ? 'IT - Italiano' : 'IT | Italiano'}
            </button>
          </div>

          <div className={`lang-actions__item ${currentLanguage === 'fr' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('fr')} className="lang-actions__btn btn">
              {currentLanguage === 'fr' ? 'FR - Français' : 'FR | Français'}
            </button>
          </div>

          <div className={`lang-actions__item ${currentLanguage === 'es' ? 'lang-actions__item--selected' : ''}`}>
            <button onClick={() => changeLanguage('es')} className="lang-actions__btn btn">
              {currentLanguage === 'es' ? 'ES - Español' : 'ES | Español'}
            </button>
          </div>
        </div>
      </div>
      <div className="overflow-bg" onClick={closeLanguageModal}></div>
    </div>
  );
};

export default Header;
